const frTrans = {
   "?Français": "Français",
   "?Anglais": "Anglais",
};

export default frTrans;
